/* eslint-disable @typescript-eslint/naming-convention */
import pushClevertapEvent from '../pushClevertapEvent';

export function inventorySupplierStart() {
  pushClevertapEvent('Inventory Supplier Start');
}

export function inventorySupplierSelect({ supplier }) {
  pushClevertapEvent('Inventory Supplier Update', {
    'Supplier Name': supplier.name,
    'Supplier Address': supplier.address,
    'Supplier Phone': supplier.phone,
    'Supplier Email': supplier.email,
  });
}

export function inventorySupplierCreate({ supplier }) {
  pushClevertapEvent('Inventory Supplier Create', {
    Name: supplier.name,
    Email: supplier.email,
    Phone: supplier.phone,
    Address: supplier.address,
    City: supplier.city,
    State: supplier.state,
    Zip: supplier.postal_code,
  });
}

export function inventorySupplierDelete({ supplier }) {
  pushClevertapEvent('Inventory Supplier Delete', {
    Name: supplier.name,
    Email: supplier.email,
    Phone: supplier.phone,
    Address: supplier.address,
    City: supplier.city,
    State: supplier.state,
    Zip: supplier.postal_code,
  });
}

export function inventorySupplierExport() {
  pushClevertapEvent('Inventory Supplier Export');
}
